import { Roofing, RssFeed, Settings } from "@mui/icons-material";

export type Imenu = {
  title: string;
  name: string;
  icon?: JSX.Element;
  children?: Imenu[];
};

export const systemMenu: Imenu[] = [
  {
    title: "系统设置",
    name: "config",
    icon: <Settings />,
    children: [
      {
        title: "用户",
        name: "",
      },
    ],
  },
];


export const newsMenu: Imenu[] = [
  {
    title: "新闻审核",
    name: "news",
    icon: <RssFeed />,

  },
  {
    title: "小程序首页",
    name: "homepage",
    icon: <Roofing />,
    children: [
      {
        title: "首页管理",
        name: "",
      },
      {
        title: "发布",
        name: "publish",
      },
    ],
  }
];
